<template>
  <popover placement="top">
    <span :class="['af-icons', 'af-icons-help', alignment]"></span>
    <div slot="content">
      {{ content }}
    </div>
  </popover>
</template>

<script>
import { Popover } from 'vue-bootstrap';

export default {
  components: {
    Popover
  },
  props: {
    content: {
      type: String,
      required: true
    },
    align: {
      type: String,
      default: ''
    }
  },
  computed: {
    alignment() {
      return this.align !== '' ? `align-${this.align}` : '';
    }
  }
};
</script>
